interface AudioSessionLike {
  type: string;
}

export function preferPlayback(host: object | undefined = typeof navigator === 'undefined' ? undefined : navigator): boolean {
  const session = (host as { audioSession?: AudioSessionLike | null } | undefined)?.audioSession;
  if (session === undefined || session === null) return false;
  try {
    session.type = 'playback';
  } catch {
    return false;
  }
  return session.type === 'playback';
}
